import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, initializeAuth, indexedDBLocalPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDM-IEDQ6U3DAboRth0miRpOKDhleScrvo",
  authDomain: "tienditaescolar.firebaseapp.com",
  projectId: "tienditaescolar",
  storageBucket: "tienditaescolar.firebasestorage.app",
  messagingSenderId: "805623812527",
  appId: "1:805623812527:web:4680491cb76ed048af9f5a"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Secondary app instance — used ONLY by admin to create vendor accounts
// without losing the current admin session.
const secondaryApp = initializeApp(firebaseConfig, "Secondary");
export const secondaryAuth = getAuth(secondaryApp);

